import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchContactBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/contact-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchContactFrom = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/contact-description`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};
